export default "__VITE_ASSET___4$tXtF0__"